import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import BusinessIcon from '@material-ui/icons/Business';
import PeopleIcon from '@material-ui/icons/People';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';

import { makeStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import PaperMaterial from '@material-ui/core/Paper';

import Can from '~/contexts/Can';
import { AbilityContext } from '~/contexts/Can';

import Info from './Info';
import GridUsers from '../components/GridUsers';
import Financial from './Financial';

const useStyles = makeStyles(() => ({
  root: {
    padding: '15px 0px 0px 0px',
  },
}));

function Tabs({ id, loading, record, setRecord }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const ability = useContext(AbilityContext);
  const [value, setValue] = React.useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <TabContext value={value}>
      <PaperMaterial>
        <TabList
          variant="scrollable"
          textColor="secondary"
          onChange={handleChange}
        >
          <Tab
            icon={<BusinessIcon />}
            label={t('corporation.tabs.data')}
            value="1"
            disabled={ability.cannot('show', 'Corporations')}
          />
          <Tab
            icon={<PeopleIcon />}
            label={t('corporation.tabs.users')}
            value="2"
            disabled={ability.cannot('show', 'Corporations')}
          />
          <Tab
            icon={<MonetizationOnIcon />}
            label={t('corporation.tabs.financial')}
            value="3"
            disabled={ability.cannot('financial', 'Corporations')}
          />
        </TabList>
      </PaperMaterial>

      <Can I="show" a="Corporations">
        <TabPanel className={classes.root} value="1">
          <Info
            id={id}
            record={record}
            setRecord={setRecord}
            loading={loading}
          />
        </TabPanel>
      </Can>
      <Can I="show" a="Corporations">
        <TabPanel className={classes.root} value="2">
          <GridUsers corporation={record} />
        </TabPanel>
      </Can>

      <Can I="financial" a="Corporations">
        <TabPanel className={classes.root} value="3">
          <Financial id={id} record={record} />
        </TabPanel>
      </Can>
    </TabContext>
  );
}

export default React.memo(withRouter(Tabs));
